import { GoogleOAuthProvider } from '@react-oauth/google';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { UpdateNotification } from './components/UpdateNotification';

// Wrap the App component with GoogleOAuthProvider
function AppWithGoogleAuth() {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.error('Missing Google Client ID');
    return null;
  }

  return (
    <GoogleOAuthProvider
      clientId={clientId}
      onScriptLoadError={() => console.error('Google API script failed to load')}
    >
      <UpdateNotification />
      <RouterProvider router={router} />
    </GoogleOAuthProvider>
  );
}

export default AppWithGoogleAuth;
